import { PathBase } from "@constellation-academy/epic-ui";

export class OffersPath extends PathBase {
	static readonly pathKey = "offers";
}
